export const useScrollIntoView = () => {
  const scrollIntoView = (ref: React.RefObject<HTMLElement>, options?: ScrollIntoViewOptions) =>
    ref.current?.scrollIntoView({
      behavior: options?.behavior || 'smooth',
      block: options?.block || 'center',
      inline: options?.inline || 'center',
    })

  return { scrollIntoView }
}
